<template>
  <v-card>
    <v-snackbar
      :color="snackbarColor"
      top
      :timeout="3000"
      relative
      v-model="snackbar"
      >{{ snackbarText }}</v-snackbar
    >
    <v-card-title class="headline"
      >Copiar enlace
      <v-btn
        style="right: 10px; top: 10px"
        icon
        color="primary"
        fab
        absolute
        @click="$emit('cancel')"
      >
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-container fluid>
        <v-row>
          <v-col cols="12" sm="9" md="9">
            <v-text-field hide-details v-model="link" rounded filled />
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-btn
              @click="copyToClipboard(link)"
              rounded
              class="mt-3"
              height="50"
              color="primary"
              block
              >Copiar</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "copy",
  props: ["link"],

  data() {
    return {
      snackbarText: "",
      snackbar: false,
      snackbarColor: "green",
    };
  },

  methods: {
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(
        () => {
          this.snackbarText = "Copiado al portapapeles";
          this.snackbar = true;
          this.snackbarColor = "green darken-2";
        },
        (err) => {
          console.error("Async: Could not copy text: ", err);
        }
      );
    },
  },
  //   data() {
  //     return {
  //       url: "",
  //     };
  //   },
};
</script>